/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd
     */
    relationshipPatternCd?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd
     */
    valueList?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd
     */
    isVisable?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'relationshipPatternCd': !exists(json, 'relationshipPatternCd') ? undefined : json['relationshipPatternCd'],
        'valueList': !exists(json, 'valueList') ? undefined : json['valueList'],
        'isVisable': !exists(json, 'isVisable') ? undefined : json['isVisable'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'relationshipPatternCd': value.relationshipPatternCd,
        'valueList': value.valueList,
        'isVisable': value.isVisable,
    };
}

